import _ from 'lodash'
import Backbone from 'backbone'
import template from './documents-edit.hbs'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import EditForm from 'scoreboard/components/edit/edit-form'
import DisplayHeader from 'scoreboard/components/display-header'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import fileInfo from 'scoreboard/components/files/file-info'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import appDisplay from 'scoreboard/components/app-display'
import momentHelper from 'scoreboard/components/moment-helper'
import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import { triggerAddOrEdit } from 'scoreboard/components/domain-object-events'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import { isV6 } from 'scoreboard/components/version'

var DocumentsEdit = Backbone.View.extend({

	// this.model is the Document

	className: 'documents-edit document-list scroll-layout-xy  documents table-hack display-layout',

	events: {
		'click .cancel': 'cancel',
		'click .download': 'downloadRevision',
		'click .delete-revision': 'deleteRevision'
	},

	initialize: function() {
		this.editForm = new EditForm({
			model: this.model,
			section: 'files',
			deleteExtraBannerMessage: this.model.deleteFileDependencyMessage()
		})

		this.formView = new FormView({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this)
		})
		this.formView.on('change', this._change.bind(this))

		this.listenTo(this.model, 'destroy:revision', this.preventDeletingOnlyRevision)
	},

	_change: function() {
		this.trigger('change', formHelper.readFromDom(this.el))
	},

	render: function() {
		this.header = new DisplayHeader({
			heading: this.model.get('label'),
			model: this.model,
			// this.subsection must be set by subclasses
			subsection: 'edit',
			tabs: tabs({
				id: this.model.id || this.model.get('parentId'),
				section: 'files',
				overviewTabCode: 'common.overview',
				hideAlerts: true
			})
		}).render()

		this.$el.empty().append(this.header.el, template(this.context()))
		this.$('.scroll-content-wrapper').prepend(this.editForm.el)
		this.editForm.render()
		this.preventDeletingOnlyRevision()

		this.formView.start({
			isNew: this.model.isNew(),
			primaryButtonEl: this.$('.save')
		})

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		if (isV6()) {
			this.labelField = new MarkedField({
				el: this.$('[name=label]'),
				validator: requiredValidator
			}).render()
		}

		return this
	},

	context: function() {
		var context = _.cloneDeep(this.model.attributes)
		_.each(context.revisions, function(revision) {
			revision.extension = fileInfo.extension(revision.label)
			var type = fileInfo.type(revision.label)
			revision.type = type ? 'documents.fileType.' + type : null
		})
		return context
	},

	_revisionId: function(e) {
		return this.$(e.target).closest('[data-revision-id]').data('revision-id')
	},

	downloadRevision: function(e) {
		this.model.downloadRevision(this._revisionId(e))
	},

	cancel: function() {
		this.editForm.labelField.clearError()
		this.render()
	},

	deleteRevision: function(e) {
		var revisionId = this._revisionId(e)
		var revision = this.model.revisions.get(revisionId)
		var dateTime = momentHelper.formatDateTime(revision.get('lastModified'))
		var substitution = highlight(dateTime)
		var message = i18n.get('documents.delete.revision', substitution)

		var confirmation = new DeleteConfirmation({
			message,
			extraBannerMessage: this.model.deleteRevisionDependencyMessage(revisionId)
		})
		appDisplay.dialog(confirmation)
		confirmation.on('confirm', function() {
			confirmation.trigger('done')
			this.model.destroyRevision(revisionId).then(this.render.bind(this))
		}.bind(this))
	},

	preventDeletingOnlyRevision: function() {
		var deleteControls = this.$('.delete-revision')
		if (deleteControls.length == 1) {
			deleteControls.hide()
		}
	},

	submit: function() {
		var action = this.model.isNew() ? 'add' : 'edit'
		return this.model.save({ label: this.$('[name=label]').val() }, {
			patch: true,
			success: function(model) {
				this.trigger('save', model)
				triggerAddOrEdit(action, model)

				this.formView.start({ isNew: false })
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		//this.removeChildren()
		_.invokeMap([this.formView, this.editForm, this.covertButtonTooltips], 'remove')
	}

})

export default DocumentsEdit

DocumentsEdit.__filename__ = 'documents/documents-edit.js'
